import React from 'react';
import { Button, Icon, Link, Text } from '@paypalcorp/pp-react';
export default ({ authEventHandler, localizedContent, logger }) => {
    return (React.createElement("div", { style: { textAlign: 'center' } },
        React.createElement(Text, { size: "xl2" },
            React.createElement(Icon, { name: "error", size: "xl", style: { display: 'block' } }),
            localizedContent('genericErrorHeading')),
        React.createElement(Button, { onClick: () => {
                logger.track('user_opted_out');
                authEventHandler({
                    event: 'userWantsToTryPassword',
                });
            }, style: { width: '100%', marginBottom: '20px' } }, localizedContent('loginWithPassword')),
        React.createElement(Link, { onClick: () => {
                logger.track('user_opted_out');
                authEventHandler({
                    event: 'userOptedOut',
                });
            } }, localizedContent('checkoutAsGuest'))));
};
